export default "__VITE_ASSET__DYiz8BsC__"